export default __webpack_public_path__ + "static/media/Version (6) - Ultimate Map_27.2e3d3ec9.jpg";